import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Grid, Typography } from "@mui/material";
import UrlHelper from "@/app/helpers/UrlHelper";
import Enrollment from "@/app/components/impactRewards/Enrollment";
import BalanceAndUsage from "@/app/components/impactRewards/BalanceAndUsage";
import Breadcrumbs from "@/app/components/shared/breadcrumbs";
import { PageBanner } from "@/app/components/storybook/Banner/PageBanner";
import { BannerVariantEnum } from "@/enums/tokens/bannerVariantEnum";
import { PositionTokensEnum } from "@/enums/tokens/positionTokenEnum";

const IMPACT_REWARDS_ENROLLMENT = "impactRewardsEnrollment";
const IMPACT_REWARDS_BALANCE = "impactRewardsBalance";
const TAB_QUERY_KEY = "tab";

const ProgramImpactRewards = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const currentTab =
    UrlHelper.getQueryParam(location.search, TAB_QUERY_KEY) ||
    IMPACT_REWARDS_ENROLLMENT;

  const handleTabChange = (tabKey: string) => {
    navigate({
      pathname: location.pathname,
      search: `?${TAB_QUERY_KEY}=${tabKey}`,
    });
  };

  return (
    <>
      <PageBanner
        variant={BannerVariantEnum.IMPACT}
        contentAlignment={PositionTokensEnum.LEFT}
      >
        <Typography component="h1">
          <Box component="span" sx={{ fontFamily: "Gotham-Bold" }}>
            IMPACT
          </Box>{" "}
          <Box component="span" sx={{ fontFamily: "Gotham-Book" }}>
            REWARDS
          </Box>
        </Typography>
      </PageBanner>
      <Box
        sx={{
          px: { xs: 2, sm: 4 },
          pb: { xs: 2, md: 1 },
          mx: "auto",
          maxWidth: "1300px",
          boxSizing: "border-box",
        }}
      >
        <Breadcrumbs
          items={[
            { label: "Home", to: "/" },
            {
              label: "IMPACT Programs + Rewards",
              to: "/impact-programs/impact-programs-overview",
            },
            { label: "IMPACT Rewards", to: "/impact-programs/impact-rewards" },
            {
              label:
                currentTab === IMPACT_REWARDS_BALANCE
                  ? "Balance & Usage"
                  : "Enrollment",
            },
          ]}
        />
        <Box
          sx={{
            mb: 1,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "center",
            gap: { xs: 1, sm: 2 },
          }}
        >
          <Button
            className={
              currentTab === IMPACT_REWARDS_ENROLLMENT
                ? "darkBlueButtonSolid"
                : "darkBlueButtonOutline"
            }
            onClick={() => handleTabChange(IMPACT_REWARDS_ENROLLMENT)}
          >
            ENROLLMENT
          </Button>
          <Button
            className={
              currentTab === IMPACT_REWARDS_BALANCE
                ? "darkBlueButtonSolid"
                : "darkBlueButtonOutline"
            }
            onClick={() => handleTabChange(IMPACT_REWARDS_BALANCE)}
          >
            BALANCE & USAGE
          </Button>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            {currentTab === IMPACT_REWARDS_ENROLLMENT && <Enrollment />}
            {currentTab === IMPACT_REWARDS_BALANCE && <BalanceAndUsage />}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ProgramImpactRewards;
